import InputPageLayout from "../layouts/InputPageLayout";
import SelfIntroSection from "./layouts/SelfIntroSection";

function SelfIntroduction() {
  return (
    <InputPageLayout>
      <SelfIntroSection />
    </InputPageLayout>
  );
}

export default SelfIntroduction;
